import { DataRow } from "./RecorderListContainer";
import { BasePagination } from "api/interfaces/commonInterface.interface";

import { DeregisterHelp } from "../../DeregisterHelp";
import {
  CommonTable,
  ExpandTableContainer,
} from "components/atoms/table/AntdTable";
import { TableColumnsType } from "antd";
import { ExpandableConfig } from "antd/es/table/interface";
import UpdateFirmware from "../../edit/updated";
import EditListModal from "../../edit/modal";

type Props = {
  columns: TableColumnsType<DataRow>;
  onModal: (type: string) => void;
  data: Array<DataRow>;
  selectRow: DataRow;
  paginationInfo: BasePagination;
  onChangePage: (page: number, totalRows: number) => void;
  initialPending: boolean;
  isDeregisterHelp: boolean;
  closeDeregisterHelp: () => void;
  expandableProps?: ExpandableConfig<DataRow>;
  isUpdateFirmwareModal: boolean;
  onCancelUpdateFirmware: () => void;
  isEditModal: boolean;
  openDeregisterHelp: () => void;
  autoUpdate: boolean;
};

export default function RecorderListPresenter({
  columns,
  data,
  selectRow,
  paginationInfo,
  onChangePage,
  initialPending,
  isDeregisterHelp,
  closeDeregisterHelp,
  expandableProps,
  isUpdateFirmwareModal,
  onCancelUpdateFirmware,
  isEditModal,
  onModal,
  openDeregisterHelp,
  autoUpdate,
}: Props): JSX.Element {
  return (
    <>
      <ExpandTableContainer>
        <CommonTable
          columns={columns}
          dataSource={data}
          queryInfo={paginationInfo}
          onChangePage={onChangePage}
          loading={initialPending}
          expandable={expandableProps}
          rowClassName="noPointer"
        />
      </ExpandTableContainer>

      {isEditModal && selectRow.recordId && (
        <EditListModal
          type="edit"
          selectRowId={selectRow.recordId}
          mergedSystemId={selectRow.mergedSystemId}
          onModal={(deleted?: boolean) => {
            if (
              deleted &&
              selectRow &&
              selectRow.type.toUpperCase() === "SPECTRUM"
            ) {
              openDeregisterHelp();
            }
            onModal("edit");
          }}
          isSystem={selectRow.recorderCount > 1}
        />
      )}

      {isUpdateFirmwareModal && selectRow.recordId && (
        <UpdateFirmware
          recorderId={selectRow.recordId}
          onCancelUpdateFirmware={onCancelUpdateFirmware}
          onlineStatus={selectRow.onlineStatusCount === selectRow.recorderCount}
          autoUpdate={autoUpdate}
        />
      )}
      {isDeregisterHelp && <DeregisterHelp onModal={closeDeregisterHelp} />}
    </>
  );
}
